(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bso-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      if (root.dataset.bsoTabsInitialized === 'true') {
        return;
      }
      root.dataset.bsoTabsInitialized = 'true';

      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      if (!tabs.length) {
        return;
      }

      function activate(index, shouldFocus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (panel, i) {
          var on = i === index;
          panel.toggleAttribute('hidden', !on);
          if (on) {
            var bg = panel.style.getPropertyValue('--panel-bg').trim();
            if (bg) {
              root.style.setProperty('--bso-tabs-active-panel-bg', bg);
            } else {
              root.style.removeProperty('--bso-tabs-active-panel-bg');
            }
          }
        });
        if (shouldFocus && tabs[index]) {
          tabs[index].focus();
        }
      }

      function onKey(event, i) {
        var last = tabs.length - 1;
        var next;
        switch (event.key) {
          case 'ArrowRight':
            next = i === last ? 0 : i + 1;
            break;
          case 'ArrowLeft':
            next = i === 0 ? last : i - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }
        event.preventDefault();
        activate(next, true);
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i, false);
        });
        tab.addEventListener('keydown', function (event) {
          onKey(event, i);
        });
      });
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.bso-tabs');
      roots.forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var blockId = event.detail && event.detail.blockId;
      if (!blockId) {
        return;
      }
      var tab = document.querySelector('[role="tab"][data-tab-id="' + blockId + '"]');
      if (tab) {
        tab.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
